<div class="home-background-grid">
    <div *ngFor='let theme of availableThemes; let i = index' [ngClass]="{ 'home-background-theme-item': true, 'home-background-theme-selected': getSelectedTheme() === i }" (click)="themeClick(i)">
        <div *ngIf="theme.full === ''" [ngStyle]="{ 'background': 'linear-gradient(180deg, ' + theme.start + ' 0%, ' + theme.end + ' 100%)' }"></div>
        <div *ngIf="theme.full !== ''" [ngStyle]="{ 'background': theme.full }"></div>
    </div>
</div>